<template>
    <div id="konfigurator-pohlavi">

        <h1>Pohlaví</h1>

        <div v-show="!ispohlavivalid() && this.tryescape" class="info-messages-box">
            <div v-if="!ispohlavivalid() && this.tryescape" class="error-msg">Musíte vybrat pohlaví vašeho mazlíčka
            </div>
        </div>

        <div class="form-content">

            <div class="pohlavi-pes-fena">
                <div class="form-radios"
                     v-bind:class="{ 'has-error':!ispohlavivalid() && this.tryescape }">
                    <div class="form-type-radio" v-for="item in pohlavi">
                        <input type="radio" @change="pohlaviOnChange" v-model="mazlicek.pohlavi.value" v-bind:value="item.val" :id="item.val">
                        <label :for="item.val">
                            {{ item.txt }}
                        </label>
                    </div>
                </div>
            </div>

            <div class="laktujici-fena" v-show="mazlicek.pohlavi.value === 'fena'">
                <h2>Je březí nebo kojící?</h2>
                <div class="form-radios">
                    <div class="form-type-radio" v-for="item in breziLaktujici">
                        <input type="radio" v-model="mazlicek.pohlavi.laktujici" v-bind:value="item.val"
                               :id="String(item.val) + 'laktujci'">
                        <label :for="String(item.val) + 'laktujci'">
                            {{ item.txt }}
                        </label>
                    </div>
                </div>
                <div class="veterinar-info" v-show="this.$v.mazlicek.$invalid">
                    <p>Další kroky musíme řešit individuálně. <a href="/kontakty">Ozvěte se nám.</a></p>
                </div>

            </div>

        </div>

        <info :krok="5"></info>

        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :disableNext="!valid"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>


    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    import navigace from './Navigace'
    import info from './Info'

    export default {
        components: {navigace, info},
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                pohlavi: [
                    {txt: 'Pes', val: 'pes'},
                    {txt: 'Fena', val: 'fena'}
                ],
                breziLaktujici: [
                    {txt: 'Ano', val: true},
                    {txt: 'Ne', val: false}
                ],
                tryescape: false
            }
        },
        computed: {
            valid: function () {
                return (this.mazlicek.pohlavi.valid = !this.$v.mazlicek.pohlavi.$invalid)
            }
        },
        methods: {
            animateAfterError(){
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            },
            pohlaviOnChange: function (val) {
              if(val.target.value == 'pes'){
                this.mazlicek.pohlavi.laktujici = false
              }
            },
            prev: function () {
                this.$router.push({name: 'narozeniny'})
            },
            saveAndQuit: function () {
              if (this.isstepvalid()) {
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                   this.$cookies.set('show_confirmation_message', 1)
this.$cookies.set('show_confirmation_message', 1)
                    window.location.href = 'opet-objednej/' + this.mazlicek.nid + this.mazlicek.nid
                  }, error => {
                    console.error(error)
                  })
              } else {
                this.tryescape = true
                this.animateAfterError()
              }
            },
            next: function () {
                // this.$store.commit('setMazlicek', this.mazlicek)
                if (this.isstepvalid()) {
                    this.$store.dispatch('updatePet', this.mazlicek)
                        .then(response => {

                            this.$router.push({name: 'hmotnostkondice'})

                        }, error => {
                            console.error(error)
                        })
                } else {
                    this.tryescape = true
                    this.animateAfterError()
                }
            },
            ispohlavivalid: function () {
                return this.mazlicek.pohlavi.value !== null
            },
            isstepvalid: function () {
                return this.ispohlavivalid() && this.mazlicek.pohlavi.laktujici === false
            }
        },
        validations: {
            mazlicek: {
                pohlavi: {
                    value: {
                        required,
                        valid: function () {
                            if (this.mazlicek.pohlavi.value === 'fena' && this.mazlicek.pohlavi.laktujici === true) {
                                return false
                            } else {
                                return true
                            }
                        }
                    }
                }
            }
        },
        mounted: function () {
            this.mazlicek.step.current = 4
            this.$cookies.set('lastVisitedStep', 4)
            jQuery('html, body').animate({scrollTop: 0}, '500')
        }
    }
</script>



// WEBPACK FOOTER //
// 05Pohlavi.vue?7655bdf1